import axios from "axios";
import config from "shared/config";

import { Config, TarlConfig } from "./configState";

export interface ElevateConfig {
  QUEUES: Record<string, string>;
  tarlConfig: TarlConfig;
}
export const fetchElevateConfig = async (): Promise<Config> => {
  const url = new URL("env/config", config.elevateUrl);
  const response = await axios.get<ElevateConfig>(url.toString());
  const { QUEUES: queues, tarlConfig } = response.data;
  return { queues, tarlConfig };
};
